import { Button } from '@/components/chariot-ui';
import { RocketIcon } from 'lucide-react';

export const GithubInstructions = () => {
  const url = 'https://github.com/apps/praetorian-chariot/installations/new';

  return (
    <div>
      <p className="mb-4 block text-sm leading-6">
        Install the Chariot GitHub App in your organization:
      </p>
      <div>
        <Button
          styleType="primary"
          startIcon={<RocketIcon />}
          onClick={() => {
            window.document.location = url;
          }}
          className="rounded-sm p-1!"
          label="Install GitHub App"
        />
      </div>
      <div className="relative mt-4">
        <span className="bg-chariot-background-primary text-chariot-text-primary sticky left-[200px] z-10 px-4">
          OR
        </span>
        <hr className="border-chariot-stroke absolute top-3 w-full" />
        <p className="mb-4 block text-sm leading-6">
          Provide a Workspace access token and your organization name
        </p>
      </div>
    </div>
  );
};

export const BitbucketAuthInstructions = () => {
  const url = 'https://bitbucket.org/install-chariot';

  return (
    <div>
      <p className="mb-4 block text-sm leading-6">
        Install the Chariot Bitbucket App in your organization:
      </p>
      <div>
        <Button
          styleType="primary"
          startIcon={<RocketIcon />}
          onClick={() => {
            window.document.location = url;
          }}
          className="rounded-sm"
          label="Install Bitbucket App"
        />
      </div>
      <div className="relative mt-4">
        <span className="bg-chariot-background-primary text-chariot-text-primary sticky left-[200px] z-10 px-4">
          OR
        </span>
        <hr className="border-chariot-stroke absolute top-3 w-full" />
        <p className="mb-4 block text-sm leading-6">
          Provide a Workspace access token and your organization name
        </p>
      </div>
    </div>
  );
};
